wbApp.factory('terminalSvc', ['$resource', '$q', 'repositorySvc', 'localStorageService', 'securitySvc',
    function ($resource, $q, repositorySvc, localStorageService, securitySvc) {

        var Terminal = $resource('/Api/Terminals/:id', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/Api/Terminals/GetAll' },
            'update': { method: 'POST', url: '/Api/Terminals/Update' },
            'insert': { method: 'POST', url: '/Api/Terminals/Insert' },
            'delete': { method: 'POST', url: '/Api/Terminals/Delete' }
        });

        var terminals;
        var terminalSetting = null;

        function getAllAsync(refresh) {

            if (!terminals || refresh) {
                terminals = repositorySvc.customGet('getAll', Terminal);
            }

            return terminals;
        }


        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                Terminal,                  // $resource
                terminals,                 // collection
                data,                      // entity
                successCallback,
                errorCallback,
                'terminalID');
        }


        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                Terminal,                         // $resource
                terminals,                        // collection
                data,                             // entity
                successCallback,
                errorCallback,
                'terminalID');
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                Terminal,                            // $resource
                terminals,                           // collection
                { terminalID: data.terminalID },     // entity
                successCallback,
                errorCallback,
                {
                    terminalID: data.terminalID
                },
                'terminalID');
        }

        function createNew() {
            return {
                terminalID: 0,
                fromAge: 0,
                toAge: 199,
                buildIn: false
            };
        }

        function getTerminalSetting() {
            var deferred = $q.defer();

            if (!terminalSetting) {
                terminalSetting = {
                    terminalID: null,
                    isDisabled: true,
                    isRequired: false,
                    isVisible: false,
                    $promise: deferred.promise
                };
            }

            var terminals = getAllAsync();
            terminals.$promise.then(function (data) {
                terminalSetting.isVisible = data.length > 0;
                terminalSetting.isRequired = data.length > 0;
                terminalSetting.isDisabled = data.length <= 1 || !securitySvc.isInRole('Terminal.Select');
                if (data.length === 1) {
                    terminalSetting.terminalID = data[0].terminalID;
                } else {
                    var storedTerminalID = localStorageService.get('wb_terminalID');
                    if (!!storedTerminalID) {
                        if (!!_.find(data, { terminalID: storedTerminalID })) {
                            terminalSetting.terminalID = storedTerminalID;
                        }
                        else {
                            localStorageService.remove('wb_terminalID');
                        }
                    }
                }
                deferred.resolve(terminalSetting);
            }, function (error) {
                terminalSetting.isVisible = false;
                terminalSetting.isRequired = false;
                terminalSetting.isDisabled = true;

                deferred.reject(error);
            });
            return terminalSetting;
        }

        function setTerminalSetting(setting) {
            if (!!setting.terminalID) {
                localStorageService.set('wb_terminalID', setting.terminalID);
            } else {
                localStorageService.remove('wb_terminalID');
            }
        }

        function getSelectedTerminalID() {
            if (!terminalSetting) {
                terminalSetting = getTerminalSetting();
            }

            return $q(function (resolve, reject) {
                terminalSetting.$promise.then(function (data) {
                    resolve(data.terminalID);
                }, function (error) {
                    reject(error);
                });
            });
        }

        return {
            getAllAsync: getAllAsync,
            insert: insert,
            update: update,
            remove: remove,
            createNew: createNew,
            getTerminalSetting: getTerminalSetting,
            setTerminalSetting: setTerminalSetting,
            getSelectedTerminalID: getSelectedTerminalID
        }

    }]);